module.exports = __webpack_public_path__ + "img/prize4.fe4de31d.jpg";